import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'friendlyBoolean'
})
export class FriendlyBooleanPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return value ? 'Yes' : 'No';
  }

}
